<div class="container">
  <div class="header">
    <h3>{{'NORMAL.DOWN' | translate}}</h3>
  </div>
  <div class="box-parent position-relatize z-1" *ngIf="isSuccess">
    <div class="text-center">
      <h5>
        {{'NORMAL.REQUEST' | translate}}
      </h5>
      <button class="btn btn-dv btn-wide mt-3" (click)="reloadPage()">{{'NORMAL.NEW' | translate}}</button>
    </div>
  </div>
  <div class="box-parent position-relative z-1" *ngIf="!isSuccess">
<!--    <div class="form-group row">-->
<!--      <label class="col-md-3 col-form-label">{{'TAX-B2P.TABLE.SELLER' | translate}}<span class="text-red">*</span></label>-->
<!--      <div class="col-md-9" style="margin-top: 8px;">-->
<!--        <div class="form-check form-check-inline mr-2">-->
<!--          <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" [value]="0" [(ngModel)]="requestType">-->
<!--          <label class="form-check-label ml-2" for="inlineRadio1">{{'NORMAL.COP' | translate}}</label>-->
<!--        </div>-->
<!--        <div class="form-check form-check-inline">-->
<!--          <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" [value]="1" [(ngModel)]="requestType">-->
<!--          <label class="form-check-label ml-2" for="inlineRadio2">{{'NORMAL.PEOPLE' | translate}}</label>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="form-group row">
      <label class="col-md-3 col-form-label">
        {{'FILTER.CUSTOMER-CODE' | translate}}
        <span class="text-red">*</span>
      </label>
      <div class="col-md-9">
        <div class="form-label-group">
          <input type="text" class="form-control" placeholder="{{'FILTER.CUSTOMER-CODE' | translate}}" [(ngModel)]="customerCode">
          <label>{{'FILTER.CUSTOMER-CODE' | translate}}</label>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 col-form-label">{{'FILTER.DOCUMENT-NUMBER' | translate}} <span class="text-red">*</span></label>
      <div class="col-md-9">
        <div class="form-label-group">
          <input type="text" class="form-control" [(ngModel)]="documentNumber" placeholder="{{'FILTER.DOCUMENT-NUMBER' | translate}}">
          <label for="searchText">{{'FILTER.DOCUMENT-NUMBER' | translate}}</label>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 col-form-label">{{'FILTER.PO-NUMBER' | translate}} <span class="text-red">*</span></label>
      <div class="col-md-9">
        <div class="form-label-group">
          <input type="text" class="form-control" [(ngModel)]="poNumber" placeholder="{{'FILTER.PO-NUMBER' | translate}}">
          <label for="searchText">{{'FILTER.PO-NUMBER' | translate}}</label>
        </div>
      </div>
    </div>
    <div class="m-t-10 d-none">
        <p-autoComplete [(ngModel)]="documentType" [disabled]="allDocType" field="type" [multiple]="true"
                        [suggestions]="typeSuggest" [size]="30" (completeMethod)="searchDocumentType($event)"
                        (onClear)="clearDocType()" class="dv-autocomplete" placeholder="ประเภทเอกสาร">
        </p-autoComplete>
    </div>

    <div class="form-group row">
      <label class="col-md-3 col-form-label">{{'FILTER.DOCUMENT-TYPE' | translate}} <span class="text-red">*</span></label>
        <div class="col-md-9">
          <div class="dropdown-label-group">
            <p-dropdown
              class="dv-dropdown"
              selectId="documentType"
              [options]="rdDocumentType"
              [(ngModel)]="selectedRdDocumentType"
              [autoDisplayFirst]="false"
              placeholder="{{'FILTER.DOCUMENT-TYPE' | translate}}"
            >
            </p-dropdown>
            <label for="documentType">{{'FILTER.DOCUMENT-TYPE' | translate}}</label>
          </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 col-form-label">
        {{'FILTER.DATE' | translate}}
        <span class="text-red">*</span>
      </label>
      <div class="col-md-9">
        <div class="dropdown m-t-10" #dd="ngbDropdown" ngbDropdown autoClose="outside">
          <div class="form-label-group">
            <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange" ngbDropdownToggle
              placeholder="วันที่" readonly>
            <label for="calendarDropdown">{{'NORMAL.D' | translate}}</label>
            <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
              <span class="far fa-calendar"></span>
            </div>
          </div>
          <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
            <div class="row">
              <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
              <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
            </div>
            <div (click)="$event.stopPropagation()">
              <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true" [locale]="calendarLocale">
              </p-calendar>
              <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true" [locale]="calendarLocale">
              </p-calendar>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 col-form-label">
        {{'EMAIL-DASHBOARD.EMAIL' | translate}}
        <span class="text-red">*</span>
      </label>
      <div class="col-md-9">
        <div class="form-label-group">
          <input type="text" class="form-control" [(ngModel)]="email" placeholder="xxx@xxx.com">
          <label for="searchText">{{'EMAIL-DASHBOARD.EMAIL' | translate}}</label>
        </div>
        <div class="mt-1">
          <div class="col text-center text-red">{{ errorMessage ? errorMessage : '&nbsp;' }}</div>
        </div>
      </div>
    </div>
    <div class="text-right">
      <button type="button" class="btn btn-dv btn-wide" (click)="submit()" [disabled]="!email">
        <i *ngIf="loading === true" class="fa fa-spinner fa-spin m-r-5"></i>
        <i *ngIf="loading === false" class="fa fa-paper-plane m-r-5"></i>
        {{'NORMAL.R' | translate}}
      </button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download-request/download-request.component.html